var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIconTurquoise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72176 5.69376H6.09333C7.02805 5.69385 7.89742 5.21429 8.39594 4.42361L9.36489 2.8849C9.8634 2.09422 10.7328 1.61466 11.6675 1.61475H14.8284C15.7631 1.61466 16.6325 2.09422 17.131 2.8849L18.0999 4.42361C18.5984 5.21429 19.4678 5.69385 20.4025 5.69376H22.7741C24.2773 5.69376 25.4959 6.91234 25.4959 8.41553V20.5582C25.4919 22.1179 24.2285 23.3812 22.6689 23.3852H3.827C2.26735 23.3812 1.00399 22.1179 1 20.5582V8.41553C1 6.91234 2.21858 5.69376 3.72176 5.69376Z",
    fill: "white",
    stroke: "#00B0CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2496 17.9419C15.5044 17.9419 17.3323 16.114 17.3323 13.8593C17.3323 11.6045 15.5044 9.77661 13.2496 9.77661C10.9949 9.77661 9.16699 11.6045 9.16699 13.8593C9.16699 16.114 10.9949 17.9419 13.2496 17.9419Z",
    fill: "white",
    stroke: "#00B0CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconTurquoise);
export default __webpack_public_path__ + "static/media/camera-icon-turquoise.18953f46e3aceebdba6123a8eb35ac63.svg";
export { ForwardRef as ReactComponent };